import {
  BackButton,
  Container,
  LoadingIndicator,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import { Button } from '@windmill/react-ui';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SolutionDTO } from '../../common/api/models/solution';
import { getOrganizationSolutions } from '../../common/api/solution';
import { SolutionTable } from './SolutionTable';

interface ListSolutionsProps {
  pageSize?: number;
}

export const ListSolutions: React.FunctionComponent<ListSolutionsProps> = ({
  pageSize = 5,
}) => {
  const navigate = useNavigate();
  const { currentOrg } = useOrganization();
  const [isLoading, setIsLoading] = useState(true);
  const [orgSolutions, setOrgSolutions] = useState<SolutionDTO[]>([]);

  useEffect(() => {
    if (currentOrg && currentOrg.id) {
      const getOrgSolutions = async () => {
        const solutions = await getOrganizationSolutions(currentOrg.id);
        setOrgSolutions(solutions);
        setIsLoading(false);
      };
      getOrgSolutions();
    }
  }, [currentOrg]);

  const onRegisterSolutionIntent = () => {
    navigate('/solution/create', { replace: false });
  };

  return (
    <Page>
      <Container size="medium">
        <div className="flex flex-row justify-between items-center mb-os1-spacing">
          <div className="flex flex-row items-center gap-x-3">
            <BackButton />
            <PageTitle>Solutions</PageTitle>
          </div>
          {orgSolutions && orgSolutions.length > 0 && (
            <Button
              className="h-10"
              onClick={onRegisterSolutionIntent}
              size="large"
            >
              Register Solution
            </Button>
          )}
        </div>
        {isLoading ? (
          <div className="flex flex-col items-center">
            <span className="p-8">
              <LoadingIndicator />
            </span>
          </div>
        ) : (
          <SolutionTable
            onRegisterSolutionIntent={onRegisterSolutionIntent}
            orgSolutions={orgSolutions}
            pageSize={pageSize}
          />
        )}
      </Container>
    </Page>
  );
};
